'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ApiMenuSectionSubItem = _react2['default'].createClass({
    displayName: 'ApiMenuSectionSubItem',


    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        reference: _react2['default'].PropTypes.string.isRequired,
        url: _react2['default'].PropTypes.string.isRequired,
        isInitiallyActive: _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'isActive': this.props.isInitiallyActive
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            'isActive': newProps.isInitiallyActive
        });
    },
    render: function render() {

        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu--sub-items--sub-item': true,
            'is-active': this.state.isActive
        });

        return _react2['default'].createElement(
            'div',
            { className: classes, 'data-ref': this.props.reference },
            _react2['default'].createElement(
                'a',
                { href: this.props.url },
                this.props.title
            )
        );
    }
});

module.exports = ApiMenuSectionSubItem;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/section-sub-item.jsx
 ** module id = 867
 ** module chunks = 0
 **/